import { byCurrencyRank, currencyRank, type CurrencyRow } from '@colplat/app-webledger/domain';

/**
 * The order currencies are listed in, everywhere on the page: the order the
 * Settings page gives them.
 *
 * Held here, once per page, rather than handed to every function that lays
 * out a few chips — there are a dozen of them, several pure helpers deep,
 * and threading an order through all of them is a lot of plumbing for one
 * comparison. `bootstrapWebledgerClient` sets it from the replica and again
 * whenever the replica moves, ahead of the page's own repaint, so a reorder
 * made in another window lands here before anything is redrawn.
 *
 * Alphabetical until it has been told otherwise, which is also what a book
 * whose currencies nobody has ordered gets from `currencyRank`.
 */
let compare: (a: string, b: string) => number = (a, b) => a.localeCompare(b);

export function setCurrencyOrder(currencies: readonly Pick<CurrencyRow, 'code' | 'sortOrder'>[]): void {
  compare = byCurrencyRank(currencyRank(currencies));
}

export function compareCurrencies(a: string, b: string): number {
  return compare(a, b);
}

/** A fresh array of these codes in the Settings page's order. */
export function sortCurrencies(codes: Iterable<string>): string[] {
  return [...codes].sort(compare);
}
